// extracted by mini-css-extract-plugin
export default {"container":"OrganizationSummary-module__container--t1hCa"};